<template>
  <div id="app">
    <router-view></router-view>
    <!-- <TopPanel/>
    <div class="main-container">
      <Navbar/> -->
      <!-- <div class="card-container">
    <div class="card-grid">
      <Card
        v-for="(card, index) in cards"
        :key="index"
        :imageSrc="card.imageSrc"
        :title="card.title"
        :details="card.definition"
      /> -->
      <!-- </div>
    </div>
    </div> -->

  </div>
</template>

<script>
// import Card from './components/Card.vue';
// import TopPanel from './components/TopPanel.vue';
// import Navbar from './components/Navbar.vue';
// import { onMounted } from 'vue';
// import { useAuthStore } from '@/stores/authStores';



export default {
  components: {
    // Card,
    // TopPanel,
    // Navbar
  },
  data() {
    return {
      cards: [
        {id:1,
          imageSrc: 'path/to/image1.jpg',
          title: 'Python',
          definition: 'A versatile, easy to understand Programing Languauge',
        },
        {id:2,
          imageSrc: 'path/to/image1.jpg',
          title: 'C++',
          definition: 'A Low level Programming language, that is ridiculously fast',
        },
        {id:3,
          imageSrc: 'path/to/image2.jpg',
          title: 'C#',
          definition: 'A popular prgramming language for development',
        },
        {id: 4,
          imageSrc: 'path/to/image2.jpg',
          title: 'Pandas',
          definition: 'A popular Python library.',
        },
        // Add more cards as needed
      ],
    };
  },

  // setup() {
  //   const authStore = useAuthStore();

  //   onMounted(async () => {
  //     await authStore.fetchUser();
  //   });
  // },
};
</script>


<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.main-container {
  display:flex;
}

.card-container {
  flex-grow:1;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 16px;
  padding: 16px;
  margin-top: 10px;
}

html, body {
  margin: 0px !important;
  padding: 0px !important;
}
</style>
